import { createUseStyles } from '../../theme/theming';

const useSectionStyles = createUseStyles((theme) => ({
  bannerCarouselRightSection: {
    position: 'relative',
    padding: ({ isMobile } = {}) =>
      isMobile
        ? `${theme.spacing.padding.regular}px ${theme.spacing.padding.small}px`
        : `${theme.spacing.padding.small}px ${theme.spacing.padding.medium}px`,
    background: theme?.colors?.background2,
    '&, & *, & *:before, & *:after': {
      fontFamily: theme?.typography?.fontFamily,
      boxSizing: 'border-box'
    }
    // '& h2,& h3': {
    //   fontWeight: '500',
    //   '& b,& strong': {
    //     fontWeight: '700'
    //   }
    // }
  },
  sectionContainer: {
    margin: '0 auto',
    maxWidth: ({ containerWidth } = {}) => containerWidth
  },
  centerData: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative'
  },
  contentContainer: {
    position: 'relative',
    width: '100%',
    zIndex: '1',
    // display: 'grid',
    // gridTemplateColumns: 'repeat(2,minmax(0, 1fr))',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    maxWidth: '100%',
    gap: '72px',
    justifyContent: 'space-between'
  },

  textContainer: {
    textAlign: 'left',
    // margin: '0 auto',
    maxWidth: '50%'
  },

  imageContainer: {
    width: '50%',
    position: 'relative',
    height: '90%',
    paddingBottom: ({ isCustomWebsite }) => (isCustomWebsite ? '35%' : ''),

    '& img': {
      // objectFit: 'cover'
    }
  },

  subTitleHeading: {
    marginBottom: '8px',
    fontSize: theme.typography.fontSize.subHead,
    letterSpacing: '3px',
    color: theme?.colors?.font3,
    wordBreak: 'break-word',
    maxWidth: '100%'
  },
  heading: {
    margin: '0',
    fontSize: theme.typography.fontSize.h1,
    color: theme?.colors?.font3,
    wordBreak: ({ wordBreakValue }) => wordBreakValue || 'break-word',
    fontWeight: theme.typography.fontWeight.bold,
    lineHeight: 'normal'
  },
  description: {
    margin: `${theme.spacing.margin.tiny}px 0px`,
    color: theme?.colors?.font3,
    lineHeight: '24px',
    wordBreak: 'break-word'
  },
  sideBannerImage: {
    width: '100%',
    height: 'calc(100% - 100px)',
    // objectFit: 'cover',
    objectPosition: '50% 50%'
  },
  absoluteButtonsBannerRight: {
    display: 'flex',
    gap: '20px',
    justifyContent: 'center',
    marginTop: theme.spacing.margin.tiny,
    width: '100%'
  },
  partialBackground: {
    display: 'none'
  },

  '@media screen and (max-width: 767px)': {
    partialBackground: {
      display: 'none'
    },
    contentContainer: {
      display: 'flex',
      flexDirection: 'column-reverse',
      flexFlow: 'column',
      paddingBottom: '48px',
      gap: '24px'
    },
    textContainer: {
      textAlign: 'center',
      maxWidth: '100%'
    },
    linkButton: {
      padding: '12px 16px'
    },
    imageContainer: {
      height: 'undefined',
      width: '100%',
      // paddingBottom: ({ isCustomWebsite }) =>
      //   isCustomWebsite ? '100%' : 'unset'
      aspectRatio: '4/3'
    }
  }
}));

export default useSectionStyles;
